import { Box, Stack, Typography, useTheme } from '@mui/material';
import { LOGO_HEADER_URL } from 'src/utils/constants/imagesUrl';

const PoweredByBadge = () => {
  const {
    shape: { borderRadius },
    palette: { divider },
  } = useTheme();
  return (
    <Box
      target="_blank"
      href="https://adamftd.com"
      component={'a'}
      sx={{ backdropFilter: 'blur(4px)' }}
      px={2}
      py={1}
      borderRadius={borderRadius * 2}
      border={`1px solid ${divider}`}
      position={'fixed'}
      left={20}
      bottom={20}
    >
      <Stack direction={'row'} alignItems={'center'} gap={2}>
        <Box width={40} height={24} component={'img'} src={LOGO_HEADER_URL} />{' '}
        <Typography variant="caption">Powered by ADAMftd</Typography>
      </Stack>
    </Box>
  );
};

export default PoweredByBadge;
